"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var offline_1 = require("@speedlo/tools/dist/offline");
var apollo_link_queue_1 = __importDefault(require("apollo-link-queue"));
var debug_1 = __importDefault(require("debug"));
var mobx_1 = require("mobx");
var log = debug_1.default('graphql.offline');
function createOfflineLink() {
    var offlineLink = new apollo_link_queue_1.default();
    mobx_1.autorun(function () {
        if (offline_1.isNetworkOnline()) {
            log('client is online');
            offlineLink.open();
        }
        else {
            log('client is offline');
            offlineLink.close();
        }
    });
    return offlineLink;
}
exports.createOfflineLink = createOfflineLink;
//# sourceMappingURL=createOfflineLink.js.map